import React from 'react';

function Social(){
    return(
        <>
        <div className="social">
            <ul>
                <li><a href="https://twitter.com/ChopkarAarya"><i class="fa-brands fa-twitter-square"></i></a></li>
                <li><a href="https://github.com/accodes21"><i class="fa-brands fa-facebook-square"></i></a></li>
                <li><a href="https://github.com/accodes21"><i class="fa-brands fa-github-square"></i></a></li>
            </ul>
        </div>
        </>
    )
}

export default Social;